import objetivosService from "@/service/objetivosService";
import { ref } from "vue";

export function useObjetivos() {
  const objetivos = ref([]);
  const isLoading = ref(false);

  const fetchObjetivosAcao = async (acaoId) => {
    isLoading.value = true;
    try {
      const response = await objetivosService.getObjetivosAcao(acaoId);
      objetivos.value = response || [];
      return response;
    } catch (error) {
      console.error("Erro ao buscar objetivos da ação:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const fetchObjetivosAtividade = async (atividadeId) => {
    isLoading.value = true;
    try {
      const response =
        await objetivosService.getObjetivosAtividade(atividadeId);
      objetivos.value = response || [];
      return response;
    } catch (error) {
      console.error("Erro ao buscar objetivos da atividade:", error);
    } finally {
      isLoading.value = false;
    }
  };

  const deleteObjetivo = async (objetivoId) => {
    isLoading.value = true;
    try {
      const response = await objetivosService.deletarObjetivo(objetivoId);
      return response;
    } catch (error) {
      console.error("Erro ao deletar objetivo:", error);
      throw error;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    objetivos,
    isLoading,
    isLoadingObjetivo: isLoading,
    fetchObjetivosAcao,
    fetchObjetivosAtividade,
    deleteObjetivo,
  };
}
